import Icon from '@components/atoms/icon/icon';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import { SellingOffersProductsItem } from '@interfaces/models/negotiation/domain/SellingOffersProduct';
import ProductImage from '@components/atoms/vc-images/components/product-image';
import { ImagesService } from '@services/image-service';
import { useGetOffersInfo } from '@components/organisms/negotiation-listings/listings-utils';
import styles from './product-item-list-card.module.scss';

interface ProductItemListCardProps {
  productData: SellingOffersProductsItem;
  onClick: () => void;
  isSelected: boolean;
}

export const ProductItemListCard: React.FC<ProductItemListCardProps> = ({ productData, onClick, isSelected }) => {
  const { t } = useTranslation('common');
  const { t: tA11y } = useTranslation('a11y');
  const { negotiations, product } = productData;
  const { pendingSellerActionCount } = negotiations;
  const isActiveBg = pendingSellerActionCount > 0;
  const picturePath = ImagesService.improveSEOProductPathImg(product.picturePath, product.path);

  const { offersText, isActiveOffersTextColor } = useGetOffersInfo(productData.negotiations);

  return (
    <div
      className={clsx(
        styles.productCard,
        isActiveBg && styles[`productCard--active`],
        isSelected && styles['productCard--selected'],
      )}
      onClick={onClick}
    >
      <div className={styles.productCard__imgContainer}>
        <ProductImage
          sizesOverwrite={[128]}
          src={picturePath}
          width={80}
          height={80}
          quality={70}
          alt={product.subHeadline}
          type="thumbnail"
          fetchPriority="low"
        />
      </div>
      <div className={styles.productCard__info}>
        <div
          className={styles.productCard__info__brand}
          data-cy="selling_offers_product_card_brand"
        >
          {product.headline}
        </div>
        <div
          className={styles.productCard__info__productName}
          data-cy="selling_offers_product_card_title"
        >
          {product.subHeadline}
        </div>
        <div
          className={styles.productCard__info__price}
          data-cy="selling_offers_product_card_price"
        >
          {product.price.formatted}
        </div>
        <div
          className={styles.productCard__info__youEarn}
          data-cy="selling_offers_product_card_you_earn"
        >
          {t('MMAO.SELLER.YOU_EARN')}: {product.sellerEarnings.formatted}
        </div>
        <div
          className={styles.productCard__info__offers}
          data-cy="selling_offers_product_card_offers"
        >
          <p className={isActiveOffersTextColor && styles['productCard__info__offers--active']}>{offersText}</p>
        </div>
      </div>
      <div className={styles.productCard__arrow}>
        <Icon
          name="ios-arrow-right-16"
          ariaLabel={tA11y('A11Y.ICON.ARROW_NEXT')}
        />
      </div>
    </div>
  );
};
